import { render, staticRenderFns } from "./PageRunning.vue?vue&type=template&id=4b0c9e90&"
import script from "./PageRunning.vue?vue&type=script&lang=js&"
export * from "./PageRunning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports